"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadFileModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _constants = require("util/constants");
var _Alerts = require("../../Alerts/Alerts");
var _StepTwo = _interopRequireDefault(require("../OverrideModal/StepTwo"));
var _CreateFolderStep = _interopRequireDefault(require("./CreateFolderStep"));
var _StepOne = _interopRequireDefault(require("./StepOne"));
var _StepThree = _interopRequireDefault(require("./StepThree"));
var _UploadFile = require("./UploadFile");
var _useGetManualConversionStatus = require("@/api/useGetManualConversionStatus");
var _usePostUploadFileOld2 = require("@/api/usePostUploadFileOld");
var _BackgroundContext = require("@/context/BackgroundContext");
var _DocumentGrid = require("@/pages/DocumentManagementView/DocumentGrid.utils");
require("./uploadModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var UploadFileModal = exports.UploadFileModal = function UploadFileModal(_ref) {
  var callbackClose = _ref.callbackClose,
    documents = _ref.documents,
    showModal = _ref.showModal,
    selectedPath = _ref.selectedPath;
  var _useBackground = (0, _BackgroundContext.useBackground)(),
    addBackgroundTask = _useBackground.addBackgroundTask;
  var _usePostUploadFileOld = (0, _usePostUploadFileOld2.usePostUploadFileOld)(),
    callUploadFile = _usePostUploadFileOld.mutateAsync;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)({
      top: "90%",
      right: "unset",
      left: "unset"
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    duplicateStyle = _useState4[0],
    setDuplicateStyle = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = _slicedToArray(_useState5, 2),
    disabledNext = _useState6[0],
    setDisabledNext = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    files = _useState8[0],
    setFiles = _useState8[1];
  var _useState9 = (0, _react.useState)(_constants.AlertColor.Info),
    _useState0 = _slicedToArray(_useState9, 2),
    alertColor = _useState0[0],
    setAlertColor = _useState0[1];
  var _useState1 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState1, 2),
    alertMessage = _useState10[0],
    setAlertMessage = _useState10[1];
  var _useState11 = (0, _react.useState)(""),
    _useState12 = _slicedToArray(_useState11, 2),
    folderPath = _useState12[0],
    setFolderPath = _useState12[1];
  var STEPS = [];
  var tree = (0, _DocumentGrid.getBlobTree)(documents);
  if (showModal === "create_folder") {
    STEPS.push({
      key: "create_folder",
      subtitle: "Folder name",
      body: /*#__PURE__*/_react["default"].createElement(_CreateFolderStep["default"], {
        folderPath: folderPath,
        onChangeCallback: function onChangeCallback(e) {
          var value = e.target.value;
          // Lets validate if the folder exists
          var currentParentId = null;
          var _iterator = _createForOfIteratorHelper(selectedPath),
            _step;
          try {
            var _loop = function _loop() {
              var pathSegment = _step.value;
              var foundFolder = tree.find(function (doc) {
                return doc.documentName === pathSegment.name && doc.parentId === currentParentId && doc.fileType === _constants.TYPE_FOLDER;
              });
              if (foundFolder) {
                currentParentId = foundFolder.id;
              }
            };
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var includes = tree.some(function (doc) {
            return doc.parentId === currentParentId && doc.documentName === value;
          });
          setFolderPath(value);
          setDisabledNext(!value.trim() || includes);
          return includes;
        }
      })
    });
  }
  STEPS.push({
    key: "drag",
    subtitle: 'Drag and drop your files into this area to upload or select "Browse File" to select from your desktop.',
    body: /*#__PURE__*/_react["default"].createElement(_StepOne["default"], {
      documents: documents,
      existingFiles: files,
      selectedPath: [].concat(_toConsumableArray(selectedPath), [{
        id: "constructed-".concat(folderPath),
        name: folderPath
      }]),
      callbackError: function callbackError(msg, alertColor) {
        var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        setAlertColor(alertColor);
        setAlertMessage(msg);
        setDisabledNext(disable);
        setDuplicateStyle({
          top: "",
          right: "",
          left: ""
        });
      },
      callbackSetFiles: function callbackSetFiles(files) {
        setFiles(files.map(function (f) {
          var _f$fileCategory, _f$metadata, _f$isCompleted, _f$isChecked;
          return {
            file: f.file,
            fileCategory: (_f$fileCategory = f.fileCategory) !== null && _f$fileCategory !== void 0 ? _f$fileCategory : "",
            metadata: (_f$metadata = f.metadata) !== null && _f$metadata !== void 0 ? _f$metadata : "",
            override: f.override,
            isCompleted: (_f$isCompleted = f.isCompleted) !== null && _f$isCompleted !== void 0 ? _f$isCompleted : false,
            isChecked: (_f$isChecked = f.isChecked) !== null && _f$isChecked !== void 0 ? _f$isChecked : false,
            uuid: f.uuid
          };
        }));
        setDisabledNext(files.length === 0 || files.some(function (f) {
          return f.duplicated;
        }));
      }
    })
  }, {
    key: "details",
    subtitle: 'Select document on the left-hand side then add document details on the right. click "Save" when completed for all file attachments.',
    body: /*#__PURE__*/_react["default"].createElement(_StepTwo["default"], {
      files: files,
      callbackSetMessage: function callbackSetMessage(message) {
        setAlertColor(_constants.AlertColor.Success);
        setAlertMessage(message);
      },
      callbackSetFiles: function callbackSetFiles(processedFiles) {
        setDisabledNext(processedFiles.filter(function (f) {
          return f.isCompleted;
        }).length !== files.length);
        setFiles(processedFiles);
      }
    })
  }, {
    key: "review",
    subtitle: "Review and confirm document information.",
    body: /*#__PURE__*/_react["default"].createElement(_StepThree["default"], {
      files: files
    })
  });
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    currentStepIndex = _useState14[0],
    setCurrentStepIndex = _useState14[1];
  var selectedStep = STEPS[currentStepIndex];
  var getTextOfButton = function getTextOfButton() {
    if (currentStepIndex === STEPS.length - 1) {
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: "flex",
            alignItems: "center",
            padding: "0 10px"
          }
        }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
          size: 24
        }), /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            marginLeft: 10
          }
        }, "Uploading..."));
      }
      return "Upload";
    }
    if (selectedStep.key === "create_folder") {
      return "Add";
    }
    return "Next";
  };
  var getTextOfCancelButton = function getTextOfCancelButton(currentStepIndex) {
    if (currentStepIndex === 0) {
      return "Cancel";
    }
    return "Previous";
  };
  var createBackgroundTask = function createBackgroundTask(file) {
    var _file$uuid;
    var sendData = (0, _UploadFile.createUploadRequest)([file]);
    return {
      id: "",
      //Placeholder for id
      status: _BackgroundContext.PENDING_STATUS,
      promise: callUploadFile(sendData),
      intervalId: setInterval(function () {}, 1000),
      // Placeholder, will be updated below
      createdAt: new Date(),
      file: {
        name: file.file.name,
        id: (_file$uuid = file.uuid) !== null && _file$uuid !== void 0 ? _file$uuid : ""
      },
      pollingConfig: {
        interval: 5000,
        shouldStartPolling: function shouldStartPolling(response) {
          var _response$data;
          return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.result[0]) === null || _response$data === void 0 ? void 0 : _response$data.batch_id;
        },
        pollingFunction: function pollingFunction(response) {
          var _response$data2;
          return (0, _useGetManualConversionStatus.getManualConversionStatus)(response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 || (_response$data2 = _response$data2.result[0]) === null || _response$data2 === void 0 ? void 0 : _response$data2.batch_id);
        },
        shouldContinuePolling: function shouldContinuePolling(response) {
          var _response$data3;
          if (response.httpStatus !== 200) return false;
          var files = (_response$data3 = response.data) === null || _response$data3 === void 0 || (_response$data3 = _response$data3.result[0]) === null || _response$data3 === void 0 ? void 0 : _response$data3.files;
          return files.some(function (f) {
            return f.status === "IN_PROGRESS";
          });
        }
      }
    };
  };
  var uploadFiles = function uploadFiles() {
    try {
      var filesToUpload = files.filter(function (f) {
        return f.isCompleted;
      }).map(function (item) {
        var _item$uuid;
        return {
          file: item.file,
          fileCategory: item.fileCategory,
          metadata: item.metadata,
          path: selectedPath.length === 0 ? folderPath : "".concat(selectedPath.map(function (p) {
            return p.name;
          }).join("/"), "/").concat(folderPath),
          uuid: (_item$uuid = item.uuid) !== null && _item$uuid !== void 0 ? _item$uuid : ""
        };
      });
      //Let's create the background task
      var backgroundTasks = filesToUpload.map(createBackgroundTask);
      addBackgroundTask(backgroundTasks, _BackgroundContext.UPLOAD_TASK);
    } catch (_unused) {
      setAlertColor(_constants.AlertColor.Error);
      setAlertMessage("Unexpected error while trying to upload files into the storage.");
      setIsLoading(false);
      setDisabledNext(false);
      return false;
    }
    return true;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            setDisabledNext(true);
            uploadFiles();
            callbackClose(true, files.length);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var title = selectedStep.key === "create_folder" ? "Add Folder" : "File upload";
  var getModalHeight = function getModalHeight(key) {
    var _keys$key;
    var keys = {
      review: "auto",
      create_folder: "auto"
    };
    return (_keys$key = keys[key]) !== null && _keys$key !== void 0 ? _keys$key : "65vh";
  };
  var contentHeight = getModalHeight(selectedStep.key);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Modal, {
    open: !!showModal,
    onClose: function onClose() {
      return callbackClose(false);
    },
    "data-testid": "modalUploadFiles"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-content",
    style: {
      height: contentHeight,
      width: "60vw",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "4px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-header"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackClose(false);
    },
    className: "close_icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
    icon: "bitcoin-icons:cross-filled",
    height: 30,
    color: "#000000"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "upload_title"
  }, title), /*#__PURE__*/_react["default"].createElement("span", null, selectedStep.subtitle))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-body",
    style: {
      overflowY: selectedStep.key === "review" ? "hidden" : "auto"
    }
  }, selectedStep.body), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-kb-footer",
    style: {
      marginTop: selectedStep.key === "review" ? "3%" : ""
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "save_btn",
    "data-testid": "nextStepButton",
    onClick: function onClick() {
      if (currentStepIndex === STEPS.length - 1) {
        handleSubmit();
      } else {
        setCurrentStepIndex(function (prev) {
          return prev + 1;
        });
        setDisabledNext(selectedStep.key !== "details");
      }
    },
    disabled: disabledNext
  }, getTextOfButton()), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      if (currentStepIndex === 0) {
        callbackClose(false);
      } else {
        setCurrentStepIndex(function (prev) {
          return prev - 1;
        });
      }
    },
    className: "cancel_btn",
    "data-testid": "cancelButton",
    disabled: isLoading
  }, getTextOfCancelButton(currentStepIndex))))), /*#__PURE__*/_react["default"].createElement(_Alerts.Alerts, {
    style: duplicateStyle,
    alertOpen: alertMessage !== "",
    color: alertColor,
    message: alertMessage,
    handleAlertClose: function handleAlertClose() {
      return setAlertMessage("");
    }
  }));
};